import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

function StatusOffline({ compact = false, karyawan = null }) {
  const [isOfflineReady, setIsOfflineReady] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Pengecekan cache untuk kesiapan offline
    const checkCache = async () => {
      if ('serviceWorker' in navigator && 'caches' in window) {
        try {
          const cacheNames = await caches.keys();
          const hasCache = cacheNames.some(name => name.includes('app-cache'));
          setIsOfflineReady(hasCache);
        } catch (error) {
          console.error('Gagal cek cache:', error);
        }
      }
    };

    // Pengecekan status jaringan
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Tambahkan event listener untuk status jaringan
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Jalankan pengecekan cache
    checkCache();

    // Cleanup event listener saat komponen di-unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (compact) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{
          fontSize: 11,
          fontWeight: 600,
          color: isOnline ? '#15803d' : '#dc2626',
        }}>
          {isOnline ? 'Online' : 'Offline'}
        </span>
        <div style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          backgroundColor: isOnline ? '#ecfdf5' : '#fef2f2',
          border: `1px solid ${isOnline ? '#a7f3d0' : '#fecaca'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }}>
          {isOnline ? (
            <CheckCircle2 size={15} color="#16a34a" />
          ) : (
            <XCircle size={15} color="#dc2626" />
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      {/* Kiri: Tulisan */}
      <div style={{ flex: 1, textAlign: 'center' }}>
        <div style={{ marginBottom: 4, fontSize: 14 }}>
          {isOnline ? '✅' : '❌'}
        </div>
        <div style={{ fontSize: 12, color: isOnline ? '#16cb28ff' : '#ff0000' }}>
          {isOnline ? 'Online' : 'Offline'}
          {isOfflineReady && !isOnline && ' (Siap Offline)'}
        </div>
      </div>
    </div>
  );
}

export default StatusOffline;